import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DefaultLogoContext } from "../index";
import { getReadabilityInfo } from "../../../hooks/helpersThirdStep";
import CheckCircleIcon from "./icons/CheckCircleIcon";
import ExclamationCircleIcon from "./icons/ExclamationCircleIcon";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const СheckQrReadability = ({ svgWrapperRef }) => {
  const { defaultLogoData } = useContext(DefaultLogoContext);
  const { lang, qrSettings, qrFrames, qrOptions, link, cornetsOuter } =
    useSelector((state) => ({
      lang: state.changeLang.language.stepThree.generator,
      qrSettings: state.qrSettings,
      qrFrames: state.qrFrames,
      qrOptions: state.qrOptions,
      link: state.getQrLinkSlice.link,
      cornetsOuter: state.qrSettings.cornetsOuter,
    }));
  const [isReadable, setIsReadable] = useState(true);

  useEffect(() => {
    if (!svgWrapperRef.current || !link) return;
    setTimeout(async () => {
      const readabilityInfo = await getReadabilityInfo(svgWrapperRef);
      setIsReadable(!!readabilityInfo?.decode());
    }, [500]);
  }, [qrSettings, qrFrames, qrOptions, defaultLogoData, link]);
  const tooltip = <Tooltip id="tooltip-bottom">{lang[17]}</Tooltip>;

  const content = isReadable ? (
    <div className="rounded-1 bg-success-light px-3 py-2 d-flex text-success-dark gap-2 align-items-center">
      <CheckCircleIcon />
      <div className="fs-7">
        <span className="fw-bold">{lang[13]}</span> {lang[14]}
      </div>
    </div>
  ) : (
    <div className="rounded-1 bg-warning-light px-3 py-2 d-flex text-warning-dark gap-2 align-items-center">
      <ExclamationCircleIcon />
      <div className="fs-7">
        <span className="fw-bold">{lang[15]}</span>
        {lang[16]}
      </div>
    </div>
  );

  const eyeReadabilityContent = !isReadable && cornetsOuter === "gear" && (
    <div className="rounded-1 bg-warning-light px-3 py-2 d-flex text-warning-dark gap-2 align-items-center">
      <ExclamationCircleIcon />
      <div className="fs-7">
        <span className="fw-bold">{lang[15]}</span>
        {lang[18]}
      </div>
    </div>
  );

  return (
    <OverlayTrigger key="bottom" placement="bottom" overlay={tooltip}>
      {!!eyeReadabilityContent ? eyeReadabilityContent : content}
    </OverlayTrigger>
  );
};

export default СheckQrReadability;
